import permissions from "@/config/permissions";
export default [
    {icon: "mdi-react", title: "brand", name: "brand", i18n: "Brand", permissions: [permissions["List brand"]]},
    {
        icon: "mdi-file-document",
        title: "Page_manager",
        i18n: "Page_manager",
        group: "manage_page",
        permissions: [
            permissions["Home page"], permissions["New page"], permissions["Blanco"],
            permissions["Bosch"], permissions["Wmf"], permissions["Finish"], permissions["Footer"],
            permissions["Advise page"], permissions["Menu left"], permissions["Accessory page"],
            permissions["Whybuy page"], permissions["Showroom page"], permissions["Trade in sale page"],
        ],
        items: [
            {
                name: "Home",
                title: "Home",
                icon: "dashboard",
                i18n: "Home",
                permissions: [permissions["Home page"]]
            },
            {
                name: "Page_manager",
                title: "Page_manager",
                icon: "mdi-format-list-checkbox",
                i18n: "page_news",
                permissions: [permissions["New page"]]
            },
            {
                name: "Manage_blanco",
                title: "Manage_blanco",
                icon: "mdi-tag-multiple",
                i18n: "manage_page_blanco",
                permissions: [permissions["Blanco"]]
            },
            {
                name: "Manage_bosch",
                title: "Manage_bosch",
                icon: "mdi-tag-multiple",
                i18n: "manage_page_bosch",
                permissions: [permissions["Bosch"]]
            },
            // {
            //     name: "Manage_blum",
            //     title: "Manage_blum",
            //     icon: "mdi-tag-multiple",
            //     i18n: "manage_page_blum",
            // },
            {
                name: "Manage_wmf",
                title: "Manage_wmf",
                icon: "mdi-tag-multiple",
                i18n: "manage_page_wmf",
                permissions: [permissions["Wmf"]]
            },
            {
                name: "Manage_finish",
                title: "Manage_finish",
                icon: "mdi-tag-multiple",
                i18n: "manage_page_finish",
                permissions: [permissions["Finish"]]
            },
            {
                icon: "perm_phone_msg",
                title: "Config_advise",
                name: "Config_advise",
                i18n: "advise",
                permissions: [permissions["Advise page"]]
            },
            // {
            //     icon: "mdi-account-edit",
            //     title: "config_about",
            //     name: "config_about",
            //     i18n: "about"
            // },
            {
                icon: "mdi-menu",
                title: "menu_left",
                name: "menu_left",
                i18n: "menu_left",
                permissions: [permissions["Menu left"]]
            },
            {
                icon: "mdi-wallet",
                title: "Config_accessory",
                name: "config_accessory",
                i18n: "config_accessory",
                permissions: [permissions["Accessory page"]]
            },
            {
                icon: "mdi-star",
                title: "Config_whybuy",
                name: "config_whybuy",
                i18n: "config_whybuy",
                permissions: [permissions["Whybuy page"]]
            },
            {
                icon: "mdi-store",
                title: "Config_showroom",
                name: "config_showroom",
                i18n: "config_showroom",
                permissions: [permissions["Showroom page"]]
            },
            {
                icon: "mdi-collage",
                title: "Config_footer",
                name: "config_footer",
                i18n: "config_footer",
                permissions: [permissions["Footer"]]
            },
            // {
            //     icon: "mdi-autorenew",
            //     title: "config_renew",
            //     name: "config_renew",
            //     i18n: "config_renew",
            //     permissions: [permissions["Trade in sale page"]]
            // },
        ]
    },
    {
        title: "Manage_productions",
        group: "manage_productions",
        icon: "mdi-package-variant",
        i18n: "manage_production",
        permissions: [
            permissions["List category product"], permissions["List tag"], 
            permissions["List attribute"], permissions["List product"]
        ],
        items: [
            {
                name: "Manage_category",
                title: "Manage_category",
                icon: "mdi-format-list-checkbox",
                i18n: "manage_category",
                permissions: [permissions["List category product"]]
            },
            {
                name: "Manage_tag",
                title: "Manage_tag",
                icon: "mdi-tag-multiple",
                i18n: "manage_tag",
                permissions: [permissions["List tag"]]
            },
            {
                name: "Manage_attribute",
                title: "Manage_attribute",
                icon: "mdi-tag-multiple",
                i18n: "manage_attribute",
                permissions: [permissions["List attribute"]]
            },
            {
                name: "Manage_production",
                title: "Manage_production",
                icon: "mdi-package-variant",
                i18n: "manage_production",
                permissions: [permissions["List product"]]
            },
            {
                name: "Manage_accessories",
                title: "Manage_accessories",
                icon: "mdi-wrench",
                i18n: "manage_accessories",
                permissions: [permissions["List product"]]
            },
        ],
    },
    {icon: "widgets", title: "Manage_order", name: "Manage_order", i18n: "order_management", permissions: [permissions["List order"]]},
    // { icon: "people", title: "manage_customer", name: "manage_customer", i18n: "customer_management" },
    // {icon: "mdi-file-document-edit-outline", title: "manage_news", name: "manage_news", i18n: "news_management"},
    {
        title: "Manage_news",
        group: "manage_news",
        icon: "mdi-file-document-edit-outline",
        i18n: "manage_news",
        permissions: [permissions["List category post"], permissions["List post"]],
        items: [
            {
                name: "Manage_category_post",
                title: "Manage_category_post",
                icon: "mdi-format-list-checkbox",
                i18n: "manage_category_post",
                permissions: [permissions["List category post"]]
            },
            {
                name: "Manage_new",
                title: "Manage_new",
                icon: "mdi-file-document-edit-outline",
                i18n: "manage_new",
                permissions: [permissions["List post"]]
            }
        ],
    },



    {icon: "mdi-home-variant", title: "manage_warehouse", name: "manage_warehouse", i18n: "warehouse_management"},
    {icon: "mdi-store", title: "show_room", name: "show_room", i18n: "show_room", permissions: [permissions["List show_room"]]},
    {
        icon: "mdi-camera-metering-center",
        title: "warranties_center",
        name: "warranties_center",
        i18n: "warranties_center",
        permissions: [permissions["List warranties_center"]]
    },
    {icon: "mdi-account-tie", title: "support", name: "support", i18n: "support", permissions: [permissions["List support"]]},
    {icon: "mdi-cog-outline", title: "setting", name: "setting", i18n: "setting"},
    // { icon: "mdi-cog-outline", title: "comment", name: "comment", i18n: "comment" },
    {
        title: "Manage_Promotion_Gift",
        group: "manage_promotion_gift",
        icon: "mdi-package-variant",
        i18n: "manage_promotion_gift",
        permissions: [permissions["List promotion"], permissions["List rule"]],
        items: [
            {
                name: "Manage_promotion",
                title: "Manage_promotion",
                icon: "mdi-tag-multiple",
                i18n: "manage_promotion",
                permissions: [permissions["List rule"]],
            },
            {
                name: "Manage_gift",
                title: "Manage_gift",
                icon: "mdi-gift",
                i18n: "manage_gift",
                permissions: [permissions["List promotion"]],
            },
        ],
    },
//bao hanh
    {
        title: "Manage_warranty",
        group: "manage_warranty",
        icon: "mdi-shield-check-outline",
        i18n: "manage_warranty",
        permissions: [permissions["List warranty"], permissions["List error"]],
        items: [
            {
                name: "Active_warranty",
                title: "Active_warranty",
                icon: "mdi-clock-outline",
                i18n: "active_warranty",
                permissions: [permissions["List warranty"]],
            },
            {
                name: "Error_product",
                title: "Error_product",
                icon: "mdi-alert-circle",
                i18n: "error_product",
                permissions: [permissions["List error"]],
            },
        ],
    },
    //binh luan danh gia
    {icon: "insert_comment", title: "comment", name: "comment", i18n: "comment", permissions: [permissions["List comment"]]},
    {icon: "perm_phone_msg", title: "advise", name: "advise", i18n: "advise", permissions: [permissions["List advise"]]},
    {icon: "mdi-map-marker", title: "wards", name: "wards", i18n: "wards", permissions: [permissions["List wards"]]},
    // {icon: "mdi-autorenew", title: "renew", name: "renew", i18n: "renew", permissions: [permissions["List trade_in_sale"]]},
];